/* CLab Market: interazioni condivise */
(function () {
  // Cart drawer
  const drawer = () => document.getElementById('CartDrawer');
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); drawer()?.setAttribute('open', ''); }
    if (e.target.closest('[data-cart-close]') || e.target.matches('[data-cart-scrim]')) drawer()?.removeAttribute('open');
  });

  // Countdown (sections/drop-countdown.liquid)
  document.querySelectorAll('[data-countdown]').forEach((el) => {
    if (!el.dataset.countdown) return; // nessuna data drop impostata: lascia 00 00 00 00
    const target = new Date(el.dataset.countdown).getTime();
    if (Number.isNaN(target)) return;
    const cells = { d: el.querySelector('[data-cd-d]'), h: el.querySelector('[data-cd-h]'), m: el.querySelector('[data-cd-m]'), s: el.querySelector('[data-cd-s]') };
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      let s = Math.max(0, Math.floor((target - Date.now()) / 1000));
      const d = Math.floor(s / 86400); s -= d * 86400;
      const h = Math.floor(s / 3600); s -= h * 3600;
      const m = Math.floor(s / 60); s -= m * 60;
      cells.d.textContent = pad(d); cells.h.textContent = pad(h); cells.m.textContent = pad(m); cells.s.textContent = pad(s);
    };
    tick(); setInterval(tick, 1000);
  });

  // Accordion: uno aperto alla volta per gruppo
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-accordion-trigger]');
    if (!btn) return;
    const item = btn.closest('[data-accordion-item]');
    const group = item.closest('[data-accordion-group]');
    const wasOpen = item.hasAttribute('open');
    group?.querySelectorAll('[data-accordion-item][open]').forEach((i) => i.removeAttribute('open'));
    if (!wasOpen) item.setAttribute('open', '');
  });

  // Quantity stepper
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-btn]');
    if (!b) return;
    const input = b.parentElement.querySelector('input[name="quantity"], [data-qty-value]');
    const cur = parseInt(input.value || input.textContent, 10) || 1;
    const next = Math.min(9, Math.max(1, cur + (b.dataset.qtyBtn === 'inc' ? 1 : -1)));
    if ('value' in input) input.value = next; else input.textContent = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Gallery prodotto: click sulla thumbnail → immagine principale
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    const main = document.querySelector('[data-gallery-main]');
    if (main) { main.src = thumb.dataset.full; main.dataset.zoom = thumb.dataset.zoom || thumb.dataset.full; main.removeAttribute('srcset'); }
    document.querySelectorAll('[data-gallery-thumb] img').forEach((img) => { img.style.border = '2px solid #C9BDA4'; });
    const img = thumb.querySelector('img');
    if (img) img.style.border = 'var(--border)';
  });

  // Lightbox: click sull'immagine principale → anteprima a schermo intero
  document.addEventListener('click', (e) => {
    const main = e.target.closest('[data-gallery-main]');
    if (!main) return;
    let lb = document.getElementById('ClabLightbox');
    if (!lb) {
      lb = document.createElement('div');
      lb.id = 'ClabLightbox';
      lb.innerHTML = '<img alt=""><button type="button" aria-label="Chiudi">✕</button>';
      lb.addEventListener('click', () => lb.removeAttribute('open'));
      document.body.appendChild(lb);
    }
    lb.querySelector('img').src = main.dataset.zoom || main.src;
    lb.setAttribute('open', '');
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.getElementById('ClabLightbox')?.removeAttribute('open');
      drawer()?.removeAttribute('open');
    }
  });

  // Correlati prodotto via Section Rendering API
  document.querySelectorAll('[data-recommendations]').forEach(async (el) => {
    try {
      const res = await fetch(el.dataset.recommendationsUrl);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; el.style.display = ''; }
    } catch (e) { /* rete assente: lasciamo la sezione nascosta */ }
  });

  // Ricarica il contenuto del drawer dal server (Section Rendering API):
  // il markup del carrello resta un'unica fonte di verit\u00E0, il Liquid della sezione.
  const refreshDrawer = async () => {
    try {
      const res = await fetch('/?sections=cart-drawer');
      const sections = await res.json();
      const wrapper = document.getElementById('shopify-section-cart-drawer');
      if (!wrapper || !sections['cart-drawer']) return;
      const wasOpen = drawer()?.hasAttribute('open');
      const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const fresh = doc.getElementById('shopify-section-cart-drawer');
      if (fresh) wrapper.innerHTML = fresh.innerHTML;
      if (wasOpen) drawer()?.setAttribute('open', '');
    } catch (e) { /* rete assente: il drawer resta con l'ultimo stato noto */ }
  };

  const updateCounts = (cart) =>
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });

  // Quantit\u00E0 nel drawer \u2192 /cart/change.js \u2192 drawer rirenderizzato
  document.addEventListener('change', async (e) => {
    const lineEl = e.target.closest('[data-line-item]');
    if (!lineEl || !e.target.matches('[data-qty-value]')) return;
    const quantity = parseInt(e.target.textContent, 10);
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineEl.dataset.lineItem, quantity }),
    });
    updateCounts(await res.json());
    await refreshDrawer();
  });

  // Add to cart via AJAX API + feedback "Aggiunta!" + drawer aggiornato e aperto
  document.addEventListener('submit', async (e) => {
    // Intercetta anche i form prodotto la cui action è /cart/add, nel caso
    // l'attributo data-ajax-cart non venga renderizzato dal tag form di Shopify.
    const form = e.target.closest('form[data-ajax-cart], form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const original = btn.textContent;
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
      if (!res.ok) throw new Error('add fallita');
      btn.textContent = btn.dataset.addedLabel || 'Aggiunta! \u270C';
      updateCounts(await (await fetch('/cart.js')).json());
      await refreshDrawer();
      drawer()?.setAttribute('open', '');
    } finally {
      setTimeout(() => { btn.textContent = original; }, 1800);
    }
  });
})();
